import React from 'react';

export function MarketplaceSection() {
  return (
    <section 
      className="tw-self-center tw-mt-20 md:tw-mt-32 tw-mx-auto" 
      style={{maxWidth: "1293px"}}
      aria-labelledby="marketplace-heading"
    >
      <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-24 tw-px-4">
        <div style={{maxWidth: '530px'}}>
          <div className="tw-flex tw-flex-col tw-mt-1.5 tw-text-neutral-800">
            <h2 
              id="marketplace-heading"
              className="tw-text-5xl md:tw-text-6xl tw-capitalize tw-leading-[67px]"
            >
              Our Marketplace Funds Nonprofits & Local Projects
            </h2>
            <p className="tw-mt-4 tw-mb-0 tw-text-xl tw-font-semibold tw-leading-6">
              We provide a profitable and values-aligned vehicle for moving excess inventory or repurposed excess materials.
            </p>
            <p className="tw-mt-10 tw-text-xl tw-leading-6">
              Conscious consumers shop past season and one-of-a-kind pieces from sustainable brands and give to charity while they shop--at no added cost to them.
            </p>
          </div>
        </div>
        <div style={{maxWidth: '695px'}}>
          <img
            loading="lazy"
            src="https://expertpeople.imgix.net/assets/images/forbrands-marketplace.png?auto=format"
            alt="Visual representation of marketplace impact"
            className="tw-object-contain tw-w-full tw-rounded-none"
          />
        </div>
      </div>
    </section>
  );
}
